<template>
	<div class="container-fluid">
		<loading
            :active.sync="isLoading" 
            :can-cancel="true" 
            :is-full-page="true"
            color="#007bff"
      		background-color="#ffffff"
        >
        </loading>
        <div class="m-2">
			<div class="alert alert-primary h4 text-center">
                <linkto :link="'/'"/>
                Kiegyenlítések keresése
    		</div>
		</div>

		<div class="row d-flex justify-content-center align-items-center text-center mt-2 mb-2 no-gutters">
			<div class="col-6 col-lg-2">
				<div class="m-1">
	          		<span class="h6">Rendelés státusza</span>
	          		<select v-model="search.aktiv" class="form-control">
				  		<option value="0">Lezárt</option>
				  		<option value="1">Nyitott</option>
				  		<option value="2">Mindkettő</option>
					</select>
				</div>
	        </div>
	        <div class="col-6 col-lg-2">
	        	<div class="m-1">
	          		<span class="h6">Számlázva</span>
	          		<select v-model="search.szamlazva" class="form-control">
			  			<option value="0">Nincs számlázva</option>
			  			<option value="1">Számlázva</option>
			  			<option value="2">Mindkettő</option>
					</select>
				</div>
	        </div>
	        <div class="col-6 col-lg-2">
	        	<div class="m-1">
	            	<span class="h6">Régió</span>
	            	<div class="input-group">
	              		<input
	              			type="number"
	              			class="form-control text-center"
	              			v-model="search.regio_kezd"
	              		></input>
	              		<input
	              			type="number"
	              			class="form-control text-center"
	              			v-model="search.regio_veg"
	              		></input>
	            	</div>
	            </div>
	        </div>
	        <div class="col-12 col-lg-6">
	        	<button
	        		class="btn btn-outline-primary m-1"
	        		@click.prevent="regio_set(v.start,v.end)"
	        		v-for="(v,k) in regioButtons"
	        		:key="k"
	        	>
	        		{{v.start}}-{{v.end}}
	        	</button>
	        </div>
		</div>

		<div class="row d-flex justify-content-center text-center no-gutters">
			<div class="col-6 col-md-6 col-lg-2">
	          	<div class="m-1">
	            	<span class="h6">Ügyfél név</span>
	            	<span
	            		class="h6 text-danger clear"
	            		v-show="search.nev != ''"
	            		@click.prevent="clear('nev')"
	            	>
	            		X
	            	</span>
	            	<div class="input-group">
	              		<input
	              			type="text"
	              			class="form-control text-center"
	              			v-model="search.nev"
	              		></input>
	            	</div>
	          	</div>
	        </div>
	        <div class="col-6 col-md-6 col-lg-2">
	          	<div class="m-1">
	            	<span class="h6">Ügyfél sorszám</span>
	            	<span
	            		class="h6 text-danger clear"
	            		v-show="search.uszam != ''"
	            		@click.prevent="clear('uszam')"
	            	>
	            		X
	            	</span>
	            	<div class="input-group">
	              		<input
	              			type="text"
	              			class="form-control text-center"
	              			v-model="search.uszam"
	              		></input>
	            	</div>
	          	</div>
	        </div>
			<div class="col-6 col-md-6 col-lg-2">
	          	<div class="m-1">
	            	<span class="h6">Ügyfél város</span>
	            	<span
	            		class="h6 text-danger clear"
	            		v-show="search.varos != ''"
	            		@click.prevent="clear('varos')"
	            	>
	            		X
	            	</span>
	            	<div class="input-group">
	              		<input 
	              			type="text"
	              			class="form-control text-center"
	              			v-model="search.varos"
	              		></input>
	            	</div>
	          	</div>
	        </div>
			<div class="col-6 col-md-6 col-lg-2">
	          	<div class="m-1">
	            	<span class="h6">Ügyfél cím</span>
	            	<span
	            		class="h6 text-danger clear"
	            		v-show="search.cim != ''"
	            		@click.prevent="clear('cim')"
	            	>
	            		X
	            	</span>
	            	<div class="input-group">
	              		<input
	              			type="text"
	              			class="form-control text-center"
	              			v-model="search.cim"
	              		></input>
	            	</div>
	          	</div>
	        </div>
	        <div class="col-6 col-md-6 col-lg-2">
	        	<div class="m-1">
	            	<span class="h6">Kiegyenlítve</span>
	            	<select v-model="search.fizetve" class="form-control">
				  		<option value="0">NEM</option>
				  		<option value="1">IGEN</option>
					</select>
				</div>
	        </div>
	        <div class="col-6 col-lg-2">
	        	<div class="m-1">
	        		<span class="h6">Kiegyenlítés helye</span>
	        		<select v-model="search.fizetve_hely" class="form-control">
							<option value="99">Minden</option>
							<option
								v-for="(v,k) in penztar"
								:key="k"
								:value="v.id"
							>
								{{ v.nev }}
							</option>
					</select>
				</div>
        	</div>
	    </div>

		<div class="row d-flex justify-content-center align-items-center text-center mt-2 mb-2 no-gutters">
			<div class="col-6 col-lg-2">
	          	<div class="m-1">
		          	<span class="h6">Szolgáltató</span>
		          	<select v-model="search.szolg" class="form-control">
					  	<option
					  		v-for="(item,index) in szolg"
					  		:value="item.id"
					  		:key="`szolg-${index}`"
					  	>
					  		{{item.nev}}
					  	</option>
					</select>
	          	</div>
	        </div>
	        <div class="col-6 col-lg-2">
	        	<div class="m-1">
		          	<span class="h6">Számla kiállító</span>
		          	<select v-model="search.szla_szolg" class="form-control">
					  	<option
					  		v-for="(item,index) in szolg"
					  		:value="item.id"
					  		:key="`szolg-${index}`"
					  	>
					  		{{item.nev}}
					  	</option>
					</select>
				</div>
	        </div>
	        <div class="col-6 col-lg-2">
	        	<div class="m-1">
		          	<span class="h6">Számla típus</span>
		          	<select v-model="search.szla_tipus" class="form-control">
					  	<option
					  		v-for="(item,index) in szla_tipusok"
					  		:value="item.id"
					  		:key="`szt-${index}`"
					  	>
					  		{{item.nev}}
					  	</option>
					</select>
				</div>
	        </div>
		</div>

	    <div class="row d-flex justify-content-center align-items-center text-center mt-2">
	    	<div class="col-12 col-lg-2">
        		<div class="h6">Kiegyenlítési dátum</div>
        	</div>
	    	<div class="col-6 col-lg-2">
	    		<date-picker
	    			class="text-center"
	    			v-model="search.fizetve_datum_tol"
	    			:config="date_options"
	    			placeholder="-tól"
	    		/>
  			</div>
  			<div class="col-6 col-lg-2">
        		<date-picker
        			class="text-center"
        			v-model="search.fizetve_datum_ig"
        			:config="date_options"
        			placeholder="-ig"
        		/>
        	</div>
        	<div class="col-6 col-lg-3">
        		<button
	        		class="btn btn-outline-primary m-1"
	        		@click.prevent="setDate('prevWeek')"
	        	>
	        		Előző hét
	        	</button>
	        	<button
	        		class="btn btn-outline-primary m-1"
	        		@click.prevent="setDate('akt')"
	        	>
	        		Aktuális hét
	        	</button>
        	</div>
	    </div>
	    <div class="row d-flex justify-content-center mt-2">
			<button
				class="btn btn-lg btn-outline-danger m-1"
				@click.prevent="defaultsearch"
			>
				Keresési feltételek alapértelmezése
			</button>
			<button
				class="btn btn-lg btn-outline-primary m-1"
				@click.prevent="getsearch"
			>
				Keresés
			</button>
			<button
				class="btn btn-lg btn-warning m-1"
				disabled
			>
				{{list.length}} rendelés
			</button>
		</div>
		<div class="row d-flex justify-content-center">
			<div class="col-10"><hr></div>
		</div>
		<div class="table-wrapper table-responsive mb-3" v-if="list.length > 0">
			<table class="table table-striped">
				<thead>
					<th>Név</th>
					<th>Cím</th>
					<th>Összeg</th>
					<th>Megjegyzés</th>
					<th>Módosít</th>
				</thead>
				<tbody>
					<tr
						v-for="(v,k) in list"
						:key="k"
					>
						<td>{{ v.nev }}</td>
						<td>{{ v.varos }}, {{ v.cim }}</td>
						<td>{{ v.db * v.ar | huf }} Ft</td>
						<td>{{ v.fizetve_megj }}</td>
						<td>
			            	<router-link
			            		class="btn btn-outline-primary"
				                :to="`/order/${v.id}`"
				                target="_blank"
				            >
				            	Módosít
				            </router-link>
			            </td>
					</tr>
				</tbody>
			</table>
		</div>
		<div class="mt-2 text-center" v-if="list.length > 0">
			<p class="h4">Összegzés</p>
			<table class="table table-striped">
				<thead>
					<th>Pénztár</th>
					<th>Bevétel</th>
				</thead>
				<tbody>
					<tr
						v-for="(v,k) in penztarSum"
						:key="k"
					>
						<td>{{ v.penztar }}</td>
						<td>{{ v.bevetel | huf }} Ft</td>
					</tr>
				</tbody>
			</table>
		</div>
	</div>
</template>
<script type="text/javascript">
export default {
	data() {
		return {
			search: {
				nev: '',
				uszam: '',
				varos: '',
				cim: '',
				aktiv: 2,
				szamlazva: 1,
				regio_kezd: null,
				regio_veg: null,
				fizetve: 1,
				szolg: 0,
				szla_szolg: 0,
				szla_tipus: 0,
				fizetve_hely: 99,
				fizetve_datum_tol: this.$moment().startOf('week').format('YYYY-MM-DD'),
				fizetve_datum_ig: this.$moment().endOf('week').format('YYYY-MM-DD')
			},
		    szolg: [],
		    penztar: [],
		    list: [],
			listsum: [],
			listsum_payment: [],
			listsum_szolg: [],
			listsum_szolg_payment: [],
			order: 'regio',
          	order_dir: false,
		}
	},

	mounted(){
      	this.$Progress.start()
      	this.isLoading = true
      	this.req.post('/others')
          	.then(res => {
              	this.penztar = res.data.penztar
              	this.szolg = res.data.szolg
              	this.szolg.splice(0,0,{ "id": 0, "nev": "Minden", "megjegyzes": null })
              	this.$Progress.finish()
              	this.isLoading = false
          	})
          	.catch(err => {
              	this.$Progress.fail()
              	this.isLoading = false
          	})
  	},

  	methods: {
  		regio_set(from,to) {
			this.search.regio_kezd = from
			this.search.regio_veg = to
		},

		date_change(mit,method,value) {
			if(value === null) {
				this.search[mit] = null
			} else {
				this.search[mit] = method === '+' ?
				this.$moment().add(value, 'd').format('YYYY-MM-DD') : this.$moment().subtract(value, 'd').format('YYYY-MM-DD')
			}
		},

		defaultsearch(){
			this.search = {
				nev: '',
				uszam: '',
				varos: '',
				cim: '',
				aktiv: 2,
				szamlazva: 2,
				regio_kezd: null,
				regio_veg: null,
				fizetve: 1,
				szolg: 0,
				szla_szolg: 0,
				szla_tipus: 0,
				fizetve_hely: 99,
				fizetve_datum_tol: this.$moment().startOf('week').format('YYYY-MM-DD'),
				fizetve_datum_ig: this.$moment().endOf('week').format('YYYY-MM-DD')
			},
			this.list = []
			this.listsum = []
			this.listsum_szolg = []
			this.listsum_payment = []
			this.listsum_szolg_payment = []
		},

		clear(item){
			this.search[item] = ''
		},

		getsearch(){
			this.$Progress.start()
			this.isLoading = true
			this.req.post('/orders/search',{
				search: this.search,
				order: this.order,
              	order_dir: this.order_dir
			})
				.then(res => {
					this.list = res.data.list
				  	this.$Progress.finish()
				  	this.isLoading = false
				})
				.catch(err => {
					console.log(err)
					this.$Progress.fail()
					this.isLoading = false
				})
		},

		setDate(val) {
			if(val == 'akt') {
				this.search.fizetve_datum_tol = this.$moment().startOf('week').format('YYYY-MM-DD'),
				this.search.fizetve_datum_ig = this.$moment().endOf('week').format('YYYY-MM-DD')
			}
			if(val == 'prevWeek') {
				this.search.fizetve_datum_tol = this.$moment().subtract(1,'week').startOf('week').format('YYYY-MM-DD'),
				this.search.fizetve_datum_ig = this.$moment().subtract(1,'week').endOf('week').format('YYYY-MM-DD')
			}
		}
  	},

  	computed: {
  		penztarSum() {
  			let arr = []
  			this.penztar.forEach(p => {
  				let find = this.list.find(l => l.fizetve_hely == p.id)
  				if(find) {
  					let s = this.list.filter(l => l.fizetve_hely == p.id).reduce((r,c) => r + (c.db * c.ar), 0)
  					arr.push({
  						'penztar': p.nev,
  						'bevetel': s
  					})
  				}
  			})
  			return arr
  		}
  	}
}
</script>
<style type="text/css" scoped>
.clear {
	cursor: pointer;
}

.table-wrapper {
	max-height: 600px;
	overflow-y: auto;
}

thead th {
	background-color: #9ca8cb;
  	position: sticky;
  	top: 0;
}
</style>


// WEBPACK FOOTER //
// src/components/orders/balanced.vue